
  export default {
    computed: {
      card () {
        return this.$store.state.products.current;
      }
    }
  };
